import React from "react";

import withSessionHandling from "@/context/auth/withSessionHandling";
import DiagnosticsScreen from "@/screens/Settings/Troubleshooting/DiagnosticsScreen";

function Page(): React.JSX.Element {
  return <DiagnosticsScreen />;
}

export default withSessionHandling(Page);
